import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=7a140f7c"
import script from "./CallUs.vue?vue&type=script&lang=js"
export * from "./CallUs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/srv/app/components/icon/Icon.vue').default,Button: require('/srv/app/components/button/Button.vue').default})
